import React, { Fragment } from 'react';
import { ListItemButton, Typography, Collapse, Tooltip, InputLabel, FormControl, MenuItem, Stack, Alert, Select } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import DarkBackground from "./Widgets/TransparentLoadingDisplay";
import LoadingOverlay from "react-loading-overlay";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from "./Widgets/CustomToolbar";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import SuccessError from "./Widgets/SuccessError";
import Paper from '@mui/material/Paper';
import MultiSelectWithChips from "./Widgets/MultiSelectWithChips";
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import _without from "lodash/without";
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MuiToggleButton from '@mui/material/ToggleButton';
import { styled } from "@mui/material/styles";
import RadioGroup from '@mui/material/RadioGroup';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Controller } from "react-hook-form";
import moment from 'moment';
import { set } from 'date-fns';
import { de } from 'date-fns/locale';

const Networks = () => {
    const [editOpen, setEditOpen] = React.useState(false);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [deleteName, setDeleteName] = React.useState('');
    const [deleteId, setDeleteId] = React.useState('');
    const [successOpen, setSuccessOpen] = React.useState(false);
    const [errorOpen, setErrorOpen] = React.useState(false);
    const [successMessage, setSuccessMessage] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(false);
    const [generalOpen, setGeneralOpen] = useState(true);
    const [editOrAddTitle, setEditOrAddTitle] = React.useState('');
    const [accessToken, setAccessToken] = useState();
    const [refreshGrid, setRefreshGrid] = useState(0);
    const [departmentsSelected, setDepartmentsSelected] = useState([]);
    const [riskLevel, setRiskLevel] = useState('0');
    const [eolDate, setEolDate] = useState(null);
    const [riskText, setRiskText] = useState('');
    

    const HandleChange = (event) => {
        const {
            target: { value },
        } = event;
        setDepartmentsSelected(typeof value === 'string' ? value.split(',') : value,);
    };
    const handleChipDeleteForApplicableDepts = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
        // if (value === 'Other') {
        //   setotherDepartmentsShow(false);
        // }
    };
    const ToggleButton = styled(MuiToggleButton)(({ selectedColor }) => ({
        '&.Mui-selected, &.Mui-selected:hover': {
            color: 'white',
            backgroundColor: selectedColor,
        },
    }));
    const handleRiskLevelChange = (event, newValue) => {

        setRiskLevel(newValue);
    };
    const useAsyncLoad = (url) => {
        const [errorA, setErrorA] = useState(null);
        const [loading, setLoading] = useState(true);
        const [networks, setNetworks] = useState(null);
        const { getAccessTokenSilently } = useAuth0();

        async function GetNetworksData(url) {

            // const audience = 'https://piaapplication.azurewebsites.net/';

            // const accessToken = await getAccessTokenSilently({
            //     audience: audience,

            // });
            const accessToken = localStorage.getItem("userToken");

            var bearer = 'Bearer ' + accessToken;

            var networksData = await fetch(url, {
                method: 'GET',
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': bearer,
                    'Content-Type': 'application/json'
                }
            });

            var data = await networksData.json();

            data.accessToken = localStorage.getItem("userToken");
            setAccessToken( data.accessToken );

            return data;

        };

        var x = 1;
        async function loadData(url) {

            try {

                setErrorA(null);
                // if (x < 2) {
                setLoading(true);
                //}

                var data = await GetNetworksData(url);

                setNetworks(data);
                //console.log(data);

            } catch (e) {

                setLoading(false);
                setErrorOpen(true);
            } finally {

                setLoading(false);
            }
        }

        useEffect(() => {
            loadData(url);
            // eslint-disable-next-line
        }, [refreshGrid]);


        return [networks, errorA, loading];
    }


    const FetchNetworks = () => {
        const [value, error, loading] = useAsyncLoad("networks/getnetworks");
        //const [value, error, loading] = useAsyncLoad("vendors/getvendors");

        return [value, error, loading];
    }


    var returnData = FetchNetworks();
    var devicesToDisplay = [];
    //console.log(returnData);
    if (returnData[0] !== null) {
        var networksData = returnData[0].networks;
        devicesToDisplay = returnData[0].deviceList;
    }
    //console.log(dataSystemsData);

    var loading = returnData[2];
    var error = returnData[1];

    var departmentItems = [];
    var vendorsToDisplay = [];
    var pias = [];
    if (returnData[0] !== null) {

        departmentItems = returnData[0].departmentsList;
        vendorsToDisplay = returnData[0].vendorNames;
        pias = returnData[0].pias;


    }

    const closeSuccess = () => {
        setSuccessOpen(false);
    };
    const closeError = () => {
        setErrorOpen(false);
    };

    const handleCancel = () => {
        setEditOpen(false);
    };

    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };

    // const CustomDisableInputSelect = styled(Select)(() => ({
    //     ".MuiInputBase-input.Mui-disabled": {
    //       WebkitTextFillColor: "#888",
    //       color: "#888"
    //     }
    //   }));

    const validationSchema = Yup.object().shape({
        id: Yup.number()
            .required('Id is required'),
        hostname: Yup.string()
            .required('Host Name is required')
            .max(500, 'Host Name must not exceed 500 characters'),
        deviceTypeId: Yup.number()
            .nullable(),
        access: Yup.string()
            .nullable()
            //.required('Module is required')
            .max(1000, 'Who has access must not exceed 1000 characters'),
        authenticationDesc: Yup.string()
            .nullable()
            .max(500, 'Authentication Description must not exceed 500 characters'),
        funcionalPurpose: Yup.string()
            .nullable()
            .max(1000, 'Function must not exceed 1000 characters'),
        ips: Yup.string()
            .nullable()
            .max(1000, 'Hostnames and IP addresses must not exceed 1000 characters'),
        vlan: Yup.string()
            .nullable()
            .max(1000, 'VLAN must not exceed 1000 characters'),
        manufacturer: Yup.string()
            .nullable()
            .max(1000, 'Manufacturer must not exceed 1000 characters'),
        model: Yup.string()
            .nullable()
            .max(1000, 'Model must not exceed 1000 characters'),
        serialNo: Yup.string()
            .nullable()
            .max(1000, 'Serial Number must not exceed 1000 characters'),
        vendorInfo: Yup.string()
            .nullable()
            .max(1000, 'Vendor Info must not exceed 1000 characters'),
        url: Yup.string()
            .nullable()
            .max(1000, 'URL must not exceed 1000 characters'),
        eolDate: Yup.date()
            .nullable(),
        ports: Yup.string()
            .nullable()
            .max(1000, 'Ports must not exceed 1000 characters'),
        cpu: Yup.string()
            .nullable()
            .max(1000, 'CPU must not exceed 1000 characters'),
        avVersion: Yup.string()
            .nullable()
            .max(1000, 'AV Version must not exceed 1000 characters'),
        edr: Yup.string()
            .nullable()
            .max(1000, 'EDR must not exceed 1000 characters'),
        operatingSystem: Yup.string()
            .nullable()
            .max(1000, 'Operating System must not exceed 1000 characters'),
        physicalLocation: Yup.string()
            .nullable()
            .max(1000, 'Physical Location must not exceed 1000 characters'),
        memory: Yup.string()
            .nullable()
            .max(1000, 'Memory must not exceed 1000 characters'),
        storageSize: Yup.string()
            .nullable()
            .max(1000, 'Storage Size must not exceed 1000 characters'),
        warrantyInfo: Yup.string()
            .nullable()
            .max(1000, 'Warranty Info must not exceed 1000 characters'),
        backupDesc: Yup.string()
            .nullable()
            .max(1000, 'Backup Description must not exceed 1000 characters'),
        riskLevel: Yup.number()
            .nullable(),
        comments: Yup.string()
            .nullable()
            .max(1000, 'Comments must not exceed 1000 characters')
    });

    const runValidations = () => {

        validationSchema
            .validate(returnData[0].applications[2], { abortEarly: false })
            .then((responseData) => {
                console.log("no validation errors");
                console.log(responseData);
                console.log(errors);
                //setCurrentErrors([]);
            })
            .catch((err) => {
                console.log(err);
                console.log(err.name); // ValidationError
                console.log(err.errors);
                //setCurrentErrors(err.errors);
            });
    };

    const {
        register,
        control,
        setValue,
        handleSubmit,
        clearErrors,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });
    const showSuccess = message => {
        setSuccessOpen(true);
        setSuccessMessage(message);
        setTimeout(() => setSuccessOpen(false), 3000);
    };

    const showError = message => {
        setErrorOpen(true);
        setErrorMessage(message);
        setTimeout(() => setErrorOpen(false), 3000);
    };
    async function saveNetworkSystem(dataSystem, saveOrAddOrDelete, accessToken) {

        var method = '';
        var url = ''
        if (saveOrAddOrDelete === 'Add') {
            method = 'POST';
            url = 'networks/';
        } else if (saveOrAddOrDelete === 'Save') {
            method = 'PUT';
            url = 'networks/' + dataSystem.id;
        }
        else if (saveOrAddOrDelete === 'Delete') {
            method = 'DELETE';
            url = 'networks/' + dataSystem.id;
        }
        dataSystem.riskLevel = riskLevel;
        dataSystem.departmentsSelected = departmentsSelected;
        var bearer = 'Bearer ' + accessToken;

        try {
            const requestOptions = {
                method: method,
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': bearer,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataSystem)
            };

            var result = await fetch(url, requestOptions);


            if (result.status === 500) {
                showError("Error saving Network System");
            } else if (result.status === 404) {
                showError("Error saving Network System");
            }

            else {
                switch (saveOrAddOrDelete) {
                    case 'Save':
                        showSuccess("Update Successful");
                        break;
                    case 'Add':
                        showSuccess("New record added successfully");
                        break;
                    case 'Delete':
                        showSuccess("Record Deleted");
                        break;
                    default:
                        showSuccess("Update Successful");

                }

            }
        } catch (e) {

            showError();
        } finally {
            setRefreshGrid(refreshGrid + 1);
            //reRender = reRender + 1;
            //console.log(reRender);
        }
    }

    const onSubmit = data => {
        //runValidations();
        
        if (data.id === -1) {
            saveNetworkSystem(data, 'Add', accessToken);
        } else {
            saveNetworkSystem(data, 'Save', accessToken);
        }
        setEditOpen(false);
    };
    //grid columns
    const columns = [
        {
            field: "Actions", width: 150, sortable: false,
            disableExport: 'true',
            renderCell: (cellValues) => {
                return (

                    <div>
                        {/* {vendorData.userAndTenant.isSuperAdmin && */}
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                                handleClickOpen(event, cellValues, networksData.accessToken);
                            }}
                        >
                            <EditIcon />
                        </Button>
                        {/* } */}

                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                                handleDeleteOpen(event, cellValues);
                            }}
                        >
                            <DeleteIcon />
                        </Button>

                    </div>
                );
            }
        },
        {
            field: 'hostname', headerName: 'Host Name', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.vendorName);

            }
        },
        // { field: 'phone', headerName: 'Phone', width: 130 },
        {
            field: 'funcionalPurpose', headerName: 'Function', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.module);

            }
        },
        {
            field: 'vendorInfo', headerName: 'Vendor', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.contact);

            }
        },

        {
            field: 'eoldate', headerName: 'End of Life', minWidth: 190, flex: 1,
            valueFormatter: (params) => params.value ? moment(params?.value).format("DD/MM/YYYY") : ''

        },

        {
            field: 'avversioning', headerName: 'AV Version', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.contact);

            }
        },
        {
            field: 'operatingSystem', headerName: 'OS', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.contact);

            }
        },


    ];

    const handleClickOpen = (event, cellValues, accessToken) => {

        var dataRow = cellValues.row;
        setValue("id", dataRow.id);
        //setDataId(dataRow.id);
        // //setAccessToken(vendorData.accessToken);
        // setValue("accessToken", accessToken);
        
        if(dataRow.id >0){
            setEditOrAddTitle('Edit');
            setValue("hostname", dataRow.hostname);
            setValue("access", dataRow.access);
            setValue("authenticationDesc", dataRow.authenticationDesc);
            setValue("funcionalPurpose", dataRow.funcionalPurpose);
            setValue("ips", dataRow.ips);
            setValue("vlan", dataRow.vlan);
            setValue("manufacturer", dataRow.manufacturer);
            setValue("model", dataRow.model);
            setValue("serialNo", dataRow.serialNo);
            setValue("vendorInfo", dataRow.vendorInfo);
            setValue("url", dataRow.url);
            setValue("eolDate", dataRow.eolDate);
            setValue("ports", dataRow.ports);
            setValue("cpu", dataRow.cpu);
            setValue("avversioning", dataRow.avversioning);
            setValue("edr", dataRow.edr);
            setValue("operatingSystem", dataRow.operatingSystem);
            setValue("physicalLocation", dataRow.physicalLocation);
            setValue("memory", dataRow.memory);
            setValue("storageSize", dataRow.storageSize);
            setValue("warrantyInfo", dataRow.warrantyInfo);
            setValue("backupDesc", dataRow.backupDesc);
            setValue("riskLevel", dataRow.riskLevel);
            setValue("comments", dataRow.comments);
            setRiskLevel(dataRow.riskLevel);
    
            setEolDate(dataRow.eoldate);
    
            setValue("deviceTypeId", dataRow.deviceTypeId);
        }
        else{
            setEditOrAddTitle('Add');
            //set the default values
            setValue("hostname", '');
            setValue("access", '');
            setValue("authenticationDesc", '');
            setValue("funcionalPurpose", '');
            setValue("ips", '');
            setValue("vlan", '');
            setValue("manufacturer", '');
            setValue("model", '');
            setValue("serialNo", '');
            setValue("vendorInfo", '');
            setValue("url", '');
            setValue("eolDate", null);
            setValue("ports", '');
            setValue("cpu", '');
            setValue("avversioning", '');
            setValue("edr", '');
            setValue("operatingSystem", '');
            setValue("physicalLocation", '');
            setValue("memory", '');
            setValue("storageSize", '');
            setValue("warrantyInfo", '');
            setValue("backupDesc", '');
            setValue("riskLevel", 0);
            setValue("comments", '');
            setRiskLevel(0);
            setValue("deviceTypeId", 0);

        }

        // setValue("tenantPiaId", dataRow.tenantPiaId);

        clearErrors();
        //setRiskLevel(dataRow.riskLevel);
        //debugger;
        //setDepartmentsSelected(dataRow.selectedDepartments);
        setEditOpen(true);
        // FetchRequests(dataRow.id, accessToken).then((requestData) => {

        //   setCurrentVendorRequests(requestData);
        // });
    };
    const handleDeleteOpen = (event, cellValues) => {
        var dataRow = cellValues.row;
        setDeleteName(dataRow.hostname);
        setDeleteId(dataRow.id)
        setDeleteOpen(true);
    };

    const handleDelete = () => {
        var data = { id: deleteId };
        // data.id = deleteId;
        //saveVendor(data, 'Delete');
        saveNetworkSystem(data, 'Delete', accessToken);
        //reRender = reRender + 1;
        setDeleteOpen(false);
    };
    const addNetworkSystem = (event, cellValues) => {

        setEditOrAddTitle('Add');
        setValue("id", -1);
        setValue("module", '');
        setValue("contact", '');
        setValue("adminAccess", '');
        setValue("source", '');
        setValue("vendorId", 0);
        setValue("tenantPiaId", 0);
        setDepartmentsSelected([]);
        clearErrors();
        setEditOpen(true);

    };
    const titleBoxBackgroundColour = '#1976d21a';
    const handleRiskText = function (newValue) {
      
        setRiskText(newValue);
    };

    if (loading) {
        return (
            // <div>
            //   Loading...
            // </div>

            <DarkBackground >
                <LoadingOverlay
                    active={true}

                    spinner={true}
                    text="Loading..."
                >
                </LoadingOverlay>
            </DarkBackground>

        )
    }
    return (

        <div>
            <SuccessError
                successMessage={successMessage}
                errorMessage={errorMessage}
                closeError={() => closeError()}
                closeSuccess={() => closeSuccess()}
                successOpen={successOpen}
                errorOpen={errorOpen}
            >
            </SuccessError>

            <Box
                component="span"
                m={1}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography variant="h3" component="h2">
                    Network Inventories and Diagrams
                </Typography>

                <Button variant="outlined" onClick={addNetworkSystem}>Add a Network System</Button>
            </Box>
            <div style={{ height: '70vh', width: '100%' }}>
                <DataGrid

                    fullWidth

                    components={{
                        Toolbar: CustomToolbar,
                    }}
                    initialState={{
                        pagination: {
                            pageSize: 1000,
                        },
                    }}
                    height='100%'
                    rows={networksData}
                    columns={columns}
                    //pageSize={100}
                    rowsPerPageOptions={[50, 100]}
                //checkboxSelection
                />

            </div>
            <Dialog open={editOpen} onClose={handleCancel} fullWidth maxWidth="md"
                PaperProps={{
                    sx: {
                        minHeight: '70%'
                    }
                }}
            >
                <DialogTitle
                    sx={{ padding: "3px 39px" }}
                >{editOrAddTitle} Network System
                    <Typography variant="inherit" sx={{ fontSize: 12, paddingLeft: 2, color: "grey" }} display='inline'>
                        * = required
                    </Typography>

                </DialogTitle>
                {/* <DialogTitle>

                    <Box
                        component="span"
                        m={1}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        // border={3}
                        sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}
                    >
                        {editOrAddTitle} Network System

                    </Box>

                </DialogTitle> */}
                <form>
                    <DialogContent>

                        <Fragment>
                            <Paper variant="outlined" >
                                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                    onClick={() => setGeneralOpen(!generalOpen)}
                                >
                                    <Grid container sx={{ justifyContent: "space-between" }} >
                                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                            Network System Information
                                        </Typography>
                                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                            {generalOpen ? <RemoveIcon /> : <AddIcon />}
                                        </Typography>

                                    </Grid>
                                </Box>


                                <Collapse in={generalOpen} width={'100%'}>
                                    <Box sx={{ border: 1 }} px={1} py={2}>
                                        <Grid container spacing={1}>
                                            {/* <Grid item xs={5} sm={5}>
                                                <MultiSelectWithChips
                                                    label="Department"
                                                    name="departmentsSelected"
                                                    control={control}
                                                    value={departmentsSelected}
                                                    infoSelected={departmentsSelected}
                                                    //infoNASelected={studentInfoNASelected}
                                                    setinfoSelected={setDepartmentsSelected}
                                                    onChange={HandleChange}
                                                    handleChipDelete={handleChipDeleteForApplicableDepts}
                                                    errors={errors.departmentItems}

                                                    items={departmentItems}
                                                >
                                                </MultiSelectWithChips>


                                                <Typography variant="inherit" color="error.main">
                                                    {errors.areaOfUseSelected?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                                                <Tooltip title="What department(s) are using this software?">
                                                    <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                                </Tooltip>
                                            </Grid> */}
                                            {/* <Grid item xs={4} sm={4} md={4}>
                                                <FormControl sx={{ m: 1, minWidth: 250, maxWidth: 300 }}
                                                    required
                                                >
                                                    <InputLabel>Vendor</InputLabel>

                                                    <Controller

                                                        required
                                                        name="vendorId"
                                                        control={control}
                                                        defaultValue=""
                                                        // {...register("vendor")}
                                                        render={({ field: { onChange, value } }) => (
                                                            <Select
                                                                //disabled={!currentUser.isSuperAdmin && !isAdding}
                                                                required
                                                                defaultValue={0}
                                                                value={value}
                                                                label="Vendor"
                                                                onChange={(e) => setValue('vendorId', e.target.value, { shouldValidate: true })}
                                                            >
                                                                {vendorsToDisplay.map((vendor, index) => <MenuItem key={index} value={vendor.id}>{vendor.name}</MenuItem>)}

                                                            </Select>
                                                        )}
                                                    />
                                                </FormControl>
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.vendorId?.message}
                                                </Typography>
                                            </Grid> */}
                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    required
                                                    id="id"
                                                    name="id"
                                                    label="ID"
                                                    fullWidth
                                                    hidden
                                                    margin="dense"
                                                    {...register('id')}

                                                />

                                            </Grid>
                                            <Grid item xs={8} sm={8}>
                                                <TextField
                                                    required
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder='Network name of the device'
                                                    id="hostname"
                                                    name="hostname"
                                                    label="Host Name"
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('hostname')}
                                                    error={errors.hostname ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.module?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4} sm={4} md={4}>
                                                <FormControl sx={{ m: 1, minWidth: 250, maxWidth: 300 }}
                                                // required
                                                >
                                                    <InputLabel>Device Type</InputLabel>

                                                    <Controller

                                                        required
                                                        name="deviceTypeId"
                                                        control={control}
                                                        defaultValue=""
                                                        // {...register("vendor")}
                                                        render={({ field: { onChange, value } }) => (
                                                            <Select
                                                                //disabled={!currentUser.isSuperAdmin && !isAdding}
                                                                required
                                                                defaultValue={0}
                                                                value={value}
                                                                label="Device Type"
                                                                onChange={(e) => setValue('deviceTypeId', e.target.value, { shouldValidate: true })}
                                                            >
                                                                {devicesToDisplay.map((device, index) => <MenuItem key={index} value={device.lookupItemId}>{device.name}</MenuItem>)}

                                                            </Select>
                                                        )}
                                                    />
                                                </FormControl>
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.vendorId?.message}
                                                </Typography>
                                            </Grid>
                                            {/* 
                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    label="Contact Names"
                                                    id="contact"
                                                    name="contact"
                                                    placeholder="The name(s) of the individual who is responsible for the data."
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('contact')}
                                                    error={errors.contact ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.contact?.message}
                                                </Typography>
                                            </Grid> */}
                                            {/* <Grid item xs={12} sm={12}>

                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Privacy Names of tech administrators who also have access to the data."
                                                    id="adminAccess"
                                                    name="adminAccess"
                                                    label="Admin Access"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('adminAccess')}
                                                    error={errors.adminAccess ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.adminAccess?.message}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={2} sm={2} md={2}>
                                                <InputLabel sx={{ paddingTop: 1.5, paddingRight: 0, paddingLeft: 1 }}>Risk Level:</InputLabel>
                                            </Grid> */}


                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Names of administrators?"
                                                    id="access"
                                                    name="access"
                                                    label="Who has access?"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('access')}
                                                    error={errors.access ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.access?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="2fa?, AD,..."
                                                    id="authenticationDesc"
                                                    name="authenticationDesc"
                                                    label="Authentication Description"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('authenticationDesc')}
                                                    error={errors.authenticationDesc ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.authenticationDesc?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="What does this serve and what is the impact of an outage."
                                                    id="funcionalPurpose"
                                                    name="funcionalPurpose"
                                                    label="Functionality and business purpose"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('funcionalPurpose')}
                                                    error={errors.funcionalPurpose ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.funcionalPurpose?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Hostnames and IP addresses"
                                                    id="ips"
                                                    name="ips"
                                                    label="Hostnames and IP addresses"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('ips')}
                                                    error={errors.ips ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.ips?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="VLAN"
                                                    id="vlan"
                                                    name="vlan"
                                                    label="VLAN"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('vlan')}
                                                    error={errors.vlan ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.vlan?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Manufacturer"
                                                    id="manufacturer"
                                                    name="manufacturer"
                                                    label="Manufacturer"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('manufacturer')}
                                                    error={errors.manufacturer ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.manufacturer?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Model"
                                                    id="model"
                                                    name="model"
                                                    label="Model"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('model')}
                                                    error={errors.model ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.model?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Serial Numbers"
                                                    id="serialNo"
                                                    name="serialNo"
                                                    label="Serial Numbers"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('serialNo')}
                                                    error={errors.serialNo ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.serialNo?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Vendor Information"
                                                    id="vendorInfo"
                                                    name="vendorInfo"
                                                    label="Vendor Information"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('vendorInfo')}
                                                    error={errors.vendorInfo ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.vendorInfo?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Web Address"
                                                    id="url"
                                                    name="url"
                                                    label="Web Address"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('url')}
                                                    error={errors.url ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.url?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={3} >
                                                {/* <FormControl sx={{ m: 0, width: 190 }}> */}
                                                {/* <InputLabel> Approved By </InputLabel> */}
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        id="eolDate"
                                                        name="eolDate"
                                                        label="End of Life Date"
                                                        {...register('eolDate')}
                                                        value={eolDate}
                                                        onChange={(newValue) => {
                                                            setEolDate(newValue);
                                                            setValue("eolDate", newValue);
                                                        }}
                                                        renderInput={(params) => <TextField  {...params} />}
                                                    />

                                                </LocalizationProvider>
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.eolDate?.message}
                                                </Typography>
                                                {/* </FormControl> */}
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Ports"
                                                    id="ports"
                                                    name="ports"
                                                    label="Ports"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('ports')}
                                                    error={errors.ports ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.ports?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="CPU"
                                                    id="cpu"
                                                    name="cpu"
                                                    label="CPU"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('cpu')}
                                                    error={errors.cpu ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.cpu?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="AV Versioning"
                                                    id="avversioning"
                                                    name="avversioning"
                                                    label="AV Versioning"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('avversioning')}
                                                    error={errors.avversioning ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.avversioning?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Endpoint detection installed on the server"
                                                    id="edr"
                                                    name="edr"
                                                    label="EDR"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('edr')}
                                                    error={errors.edr ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.edr?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Operating System"
                                                    id="operatingSystem"
                                                    name="operatingSystem"
                                                    label="Operating System"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('operatingSystem')}
                                                    error={errors.operatingSystem ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.operatingSystem?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Physical Location"
                                                    id="physicalLocation"
                                                    name="physicalLocation"
                                                    label="Physical Location"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('physicalLocation')}
                                                    error={errors.physicalLocation ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.physicalLocation?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Memory"
                                                    id="memory"
                                                    name="memory"
                                                    label="Memory"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('memory')}
                                                    error={errors.memory ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.memory?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Storage Size"
                                                    id="storageSize"
                                                    name="storageSize"
                                                    label="Storage Size"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('storageSize')}
                                                    error={errors.storageSize ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.storageSize?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Warranty Information"
                                                    id="warrantyInfo"
                                                    name="warrantyInfo"
                                                    label="Warranty Information"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('warrantyInfo')}
                                                    error={errors.warrantyInfo ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.warrantyInfo?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Backup Description"
                                                    id="backupDesc"
                                                    name="backupDesc"
                                                    label="Backup Description"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('backupDesc')}
                                                    error={errors.backupDesc ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.backupDesc?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={2} sm={2} md={2}>
                                                <InputLabel sx={{ paddingTop: 1.5, paddingRight: 0, paddingLeft: 1 }}>Risk Level:</InputLabel>
                                            </Grid>

                                            <Grid item xs={10} sm={10} md={10} >

                                                <FormControl>
                                                    {/* <FormLabel id="demo-radio-buttons-group-label">Subcontractors required to protect data</FormLabel> */}
                                                    <RadioGroup
                                                        row
                                                        aria-labelledby="demo-radio-buttons-group-label"

                                                        name="radio-buttons-group"

                                                    >
                                                        <ToggleButtonGroup value={riskLevel} exclusive onChange={handleRiskLevelChange}>
                                                            <ToggleButton value={0} selectedColor="green" onMouseEnter={() => handleRiskText("Non-Critical: Even if it wasn't recovered for weeks the impact would be minimal.")} >
                                                               
                                                                    <span> Non-Critical </span>
                                                              
                                                            </ToggleButton>
                                                            <ToggleButton value={1} selectedColor="orange" onMouseEnter={() => handleRiskText('Sensitive: It would be one to several days before its loss had any effect on the business.')}> 
                                                              
                                                                    <span> Sensitive </span>
                                                              

                                                            </ToggleButton>
                                                            <ToggleButton value={2} selectedColor="red" onMouseEnter={() => handleRiskText("Vital: absence would be felt after a few hours to a day.")}>
                                                              
                                                                    <span> Vital </span>
                                                                
                                                            </ToggleButton>
                                                            

                                                        </ToggleButtonGroup>
                                                        
                                                    </RadioGroup>
                                                </FormControl>
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.commonSense?.message}
                                                </Typography>

                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <Typography>{riskText}</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Comments"
                                                    id="comments"
                                                    name="comments"
                                                    label="Comments"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('comments')}
                                                    error={errors.comments ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.comments?.message}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Collapse>

                            </Paper>
                        </Fragment>
                    </DialogContent>

                    <DialogActions>

                        <Button color="primary" onClick={handleSubmit(onSubmit)}>Save</Button>

                        <Button onClick={handleCancel}>Cancel</Button>

                    </DialogActions>
                </form>

            </Dialog>

            <Dialog open={deleteOpen} onClose={handleDeleteCancel}>
                <DialogTitle>Delete Network System</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you wish to Delete <strong>{deleteName} ?</strong>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleDelete}>Delete</Button>
                    <Button onClick={handleDeleteCancel}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default Networks;